<template>
  <div class="Index">
    <div class="window_bg"></div>
    <div class="haerd">
      <div class="haerd_left">
        <div class="backBtn" @click.stop.prevent="goBack">返 回</div>
        <div class="title">手机基础设置</div>
      </div>
      <div class="haerd_right"></div>
    </div>

    <div class="module_box">
      <div class="health" @click.stop.prevent="goWifi">
        <div class="module_left">连接无线网wifi</div>
        <div class="module_right_icon1 Wifi1">
          <div class="module_right_icon2 Wifi2">
            <div class="module_right_icon3 Wifi3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goSpace">
        <div class="module_left">清理手机存储空间</div>
        <div class="module_right_icon1 Space1">
          <div class="module_right_icon2 Space2">
            <div class="module_right_icon3 Space3"></div>
          </div>
        </div>
      </div>

      <div class="health" @click.stop.prevent="goPassword">
        <div class="module_left">设置手机解锁密码</div>
        <div class="module_right_icon1 Password1">
          <div class="module_right_icon2 Password2">
            <div class="module_right_icon3 Password3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goSize">
        <div class="module_left">调节亮度和字号</div>

        <div class="module_right_icon1 Size1">
          <div class="module_right_icon2 Size2">
            <div class="module_right_icon3 Size3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goRingTone">
        <div class="module_left">设置手机铃声</div>

        <div class="module_right_icon1 RingTone1">
          <div class="module_right_icon2 RingTone2">
            <div class="module_right_icon3 RingTone3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goNotice">
        <div class="module_left">查看和删除通知</div>

        <div class="module_right_icon1 Notice1">
          <div class="module_right_icon2 Notice2">
            <div class="module_right_icon3 Notice3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goPermission">
        <div class="module_left">设置应用权限</div>

        <div class="module_right_icon1 Permission1">
          <div class="module_right_icon2 Permission2">
            <div class="module_right_icon3 Permission3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goDesktop">
        <div class="module_left">整理桌面图标</div>

        <div class="module_right_icon1 Desktop1">
          <div class="module_right_icon2 Desktop2">
            <div class="module_right_icon3 Desktop3"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="prompt">温馨提示：模拟体验，非真实操作。</div>
  </div>
</template>
<script>
export default {
  name: 'index',
  data () {
    return {}
  },
  created () {},

  mounted () {},
  beforeDestroy () {},

  methods: {
    async goBack () {
      this.$router.replace({
        path: '/classification'
      })
    },
    async goWifi () {
      this.$router.push({
        path: '/phoneSettings/wifi/index1'
      })
    },
    async goNotice () {
      this.$router.push({
        path: '/phoneSettings/notice/index1'
      })
    },
    async goSize () {
      this.$router.push({
        path: '/phoneSettings/size/index1'
      })
    },
    async goRingTone () {
      this.$router.push({
        path: '/phoneSettings/ringTone/index1'
      })
    },
    async goSpace () {
      this.$router.push({
        path: '/phoneSettings/space/index'
      })
    },
    async goPermission () {
      this.$router.push({
        path: '/phoneSettings/permission/index'
      })
    },
    async goDesktop () {
      this.$router.push({
        path: '/phoneSettings/desktop/index1'
      })
    },
    async goPassword () {
      this.$router.push({
        path: '/phoneSettings/password/index1'
      })
    }
  }
}
</script>

<style scoped lang="less">
.newTop {
  top: 280px !important;
}
.newpadding {
  padding: 36px 40px 0 !important;
}
.newmargin {
  margin-top: 30px !important;
}
.Index {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgb(216, 103, 255),
    rgb(227, 142, 255) 26.718%,
    rgb(255, 247, 235) 100%
  );
  background-size: 100% 100%;
  border-radius: 0px;
  .window_bg {
    position: absolute;
    top: -50px;
    left: -50px;
    width: 630px;
    height: 684px;
    background: url(@/assets/use/useIndex/window_bg.png) no-repeat center;
    background-size: 100% 100%;
  }
}
.haerd {
  padding: 40px 30px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  .haerd_left {
    position: relative;
    z-index: 1;
    .backBtn {
      cursor: pointer;
      width: 251px;
      height: 90px;
      background: url(@/assets/use/useIndex/backBtn.png) no-repeat center;
      background-size: 100% 100%;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 44px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      text-shadow: 0px 1px 5px rgba(200, 121, 0, 0.5);
      border-radius: 96.5px;
      box-shadow: 0px 6px 12px 1px rgba(182, 118, 118, 0.27);
    }
    .title {
      margin-top: 20px;
      // margin-left: 20px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: bold;
      font-size: 70px;
      width: 44vw;
      color: #ffffff;
      line-height: 1.2;
    }
  }
  .haerd_right {
    position: absolute;
    right: 50px;
    top: 40px;
    z-index: 0;
    width: 359px;
    height: 270px;
    background: url(@/assets/phoneSettings/phoneSettingsIndex/phoneSettingsIndex_subscript.png)
      no-repeat center;
    background-size: 100% 100%;
    //   opacity: 0.7;
  }
}

.module_box {
  // width: 100%;
  // margin: 0 40px 0;
  position: absolute;
  top: 360px;
  max-height: 910px;
  overflow-y: auto;
  padding-right: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: 0 30px;
  .health {
    position: relative;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    // flex-direction: column;
    align-items: center;
    width: 325px;
    padding: 27px 0;
    // height: 150px;
    background: #ffffff;
    border-radius: 15px;
    margin-bottom: 30px;
    margin-right: 30px;
    .module_left {
      display: flex;
      // justify-content: center;
      margin-left: 20px;
      align-items: center;
      width: 150px;
      // height: 71px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: 500;
      font-size: 33px;
      letter-spacing: 2px;
      color: #333333;
      // margin-left: 20px;
      z-index: 99;
    }
    .module_right_icon1 {
      width: 250px;
      height: 253px;
      position: absolute;
      right: -25%;
      top: -50%;
      .module_right_icon2 {
        width: 130px;
        height: 117px;
        position: absolute;
        left: 22%;
        bottom: 4.5%;
        .module_right_icon3 {
          width: 70px;
          height: 70px;
          position: absolute;
          left: 13.5%;
          top: 23.5%;
        }
      }
    }

    .Wifi1 {
      background: url("@/assets/colorBg/orange1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Wifi2 {
      background: url("@/assets/colorBg/orange2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Wifi3 {
      background: url("@/assets/phoneSettings/phoneSettingsIndex/wifi.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .Space1 {
      background: url("@/assets/colorBg/blue1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Space2 {
      background: url("@/assets/colorBg/blue2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Space3 {
      background: url("@/assets/phoneSettings/phoneSettingsIndex/space.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .Password1 {
      background: url("@/assets/colorBg/pink1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Password2 {
      background: url("@/assets/colorBg/pink2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Password3 {
      background: url("@/assets/phoneSettings/phoneSettingsIndex/password.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .Size1 {
      background: url("@/assets/colorBg/green1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Size2 {
      background: url("@/assets/colorBg/green2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Size3 {
      background: url("@/assets/phoneSettings/phoneSettingsIndex/size.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .RingTone1 {
      background: url("@/assets/colorBg/red1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .RingTone2 {
      background: url("@/assets/colorBg/red2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .RingTone3 {
      background: url("@/assets/phoneSettings/phoneSettingsIndex/RingTone.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .Notice1 {
      background: url("@/assets/colorBg/blue1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Notice2 {
      background: url("@/assets/colorBg/blue2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Notice3 {
      background: url("@/assets/phoneSettings/phoneSettingsIndex/notice.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .Permission1 {
      background: url("@/assets/colorBg/purple1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Permission2 {
      background: url("@/assets/colorBg/purple2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Permission3 {
      background: url("@/assets/phoneSettings/phoneSettingsIndex/permission.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .Desktop1 {
      background: url("@/assets/colorBg/orange1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Desktop2 {
      background: url("@/assets/colorBg/orange2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Desktop3 {
      background: url("@/assets/phoneSettings/phoneSettingsIndex/desktop.png")
        no-repeat center;
      background-size: 100% 100%;
    }
  }
  .health:nth-child(2n) {
    margin-right: 0;
  }
}

.prompt {
  width: 100%;
  position: absolute;
  bottom: 2vh;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 30px;
  color: #666666;
  text-align: center;
}
// }
</style>
